import { PlayerRef } from '@remotion/player';
import { useMemo } from 'react';
import { AbsoluteFill } from 'remotion';
import { byDefaultKeepAspectRatioMap } from '../utils/aspect-ratio';
import { useDrawingTool } from './use-drawing-tool';

const BLUR_DURATION_IN_FRAMES = 100;
const DEFAULT_BLUR_AMOUNT = 10;

export const BlurDrawingTool: React.FC<{
  playerRef: React.RefObject<PlayerRef | null>;
}> = ({ playerRef }) => {
  const createItemConfig = useMemo(
    () => () => ({
      type: 'blur' as const,
      blurAmount: DEFAULT_BLUR_AMOUNT,
      durationInFrames: BLUR_DURATION_IN_FRAMES,
      opacity: 1,
      borderRadius: 0,
      rotation: 0,
      keepAspectRatio: byDefaultKeepAspectRatioMap.blur,
      fadeInDurationInSeconds: 0,
      fadeOutDurationInSeconds: 0,
    }),
    [],
  );

  useDrawingTool({ playerRef, createItemConfig });

  return <AbsoluteFill style={{ zIndex: 1001 }} />;
};
